var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"coloredNumber",style:('color:' + _vm.color)},[(_vm.number)?_c('value',{attrs:{"value":_vm.number,"mode":_vm.mode}}):_c('span',[_vm._v("—")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }